import React, { memo, useState, useEffect, useRef } from "react";
import { getDocDataByRef } from "../models/DataFunctions";
import { format as timeagoFormat, register } from "timeago.js";
import fr from "timeago.js/lib/lang/fr";
import { flutterColorToHex } from "../config/theme";
import { useTheme } from "@emotion/react";
import {
  getOrgById,
  intToHexColor,
  isColorTooDark,
} from "../models/OrgFunctions";

// Register the French locale for timeago
register("fr", fr);

// Function to format DateTime to timeago string in French
export function dateTimetoInfos(date) {
  if (!(date instanceof Date)) {
    throw new Error("Invalid Date object");
  }
  return timeagoFormat(date, "fr");
}

const ConvMessage = ({
  message_folder,
  isSelected,
  orgData,
  users,
  workspaceData,
}) => {
  const [contact, setContact] = useState(null);
  const lastMessageTimeRef = useRef("");

  const [tag, setTag] = useState({ nom: "#nouveau", colorint: -2494209 });
  const [tag2, setTag2] = useState({ nom: "#nouveau", colorint: -2494209 });

  const theme = useTheme();

  useEffect(() => {
    get_conv();
  }, []);

  const get_conv = async () => {
    const tags = message_folder.tags || [];
    const my_tag = tags.find((tag) => tag.org_id === orgData.id);
    setTag(my_tag);

    const tags2 = message_folder.tags2 || [];
    const my_tag2 = tags2.find((tag) => tag.org_id === orgData.id);
    setTag2(my_tag2);

    // Only set the last_message_time once, storing it in a ref
    if (!lastMessageTimeRef.current) {
      const date = new Date(message_folder?.last_time_posted?.seconds * 1000);
      lastMessageTimeRef.current = dateTimetoInfos(date);
    }

    // Only set contact once if it’s undefined
    if (!contact) {
      let contactData;
      if (!workspaceData) {
        if (message_folder.client_type !== "particulier") {
          contactData = await getOrgById(message_folder.client_id);
        } else {
          contactData = {
            name: "Particulier",
          };
        }
      } else {
        contactData = await getOrgById(message_folder.master_id);
      }

      setContact(contactData);
    }
  };

  return (
    <div
      className={`flex flex-row h-fit p-2 w-full items-start min-h-c100 cursor-pointer rounded-lg
                  ${isSelected ? "bg-neutral-100  " : "hover:bg-neutral-50 bg-white "}`}
    >
      <div className="relative flex flex-col ml-2 w-full justify-center">
        <div className="absolute top-1 right-2 w-2 h-2 rounded-full bg-primary"></div>
        <div className="flex flex-row justify-between w-full">
          <div className="text-h2 font-medium">{message_folder?.nom}</div>
          <div className="text-h5 min-w-fit pr-6 text-shadow_50">
            {lastMessageTimeRef.current}
          </div>
        </div>
        <div className="text-h3">{contact?.name}</div>

        <div className=" flex flex-row gap-2 items-center ">
          <AssistantColorName
            users={users}
            name={message_folder?.assistant_name}
          ></AssistantColorName>
          {tag && (
            <div className="w-fit h-5 mb-2">
              <div
                className="inline-flex items-center rounded-full h-full px-2 py-1 text-h3 cursor-pointer"
                style={{
                  backgroundColor: flutterColorToHex(tag.colorint),
                  color: isColorTooDark(flutterColorToHex(tag.colorint))
                    ? "white"
                    : "black",
                }}
              >
                {tag.nom}
              </div>
            </div>
          )}
          {tag2 && (
            <div className="w-fit h-5 mb-2">
              <div
                className="inline-flex items-center rounded-full h-full px-2 py-1 text-h3 cursor-pointer"
                style={{
                  backgroundColor: flutterColorToHex(tag2.colorint),
                  color: "black",
                }}
              >
                {tag2.nom}
              </div>
            </div>
          )}
          {message_folder.reglement_state === "done" &&
            message_folder.conforme !== false && (
              <div className="text-h3 h-5 items-center">
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 text-white bg-green-400">
                  finalisé
                </div>
              </div>
            )}
          {message_folder.conforme === false && (
            <div className=" h-5 inline-flex items-center rounded-full text-h3 px-2 py-1 text-white bg-indigo-400">
              non conforme
            </div>
          )}
          {message_folder.revisions?.length === 0 && (
            <div className="inline-flex  text-h3 h-5 items-center rounded-full px-2 py-1 text-white bg-amber-400">
              revisite
            </div>
          )}
          {message_folder.reglement?.state === "wait" && (
            <div className="inline-flex  text-h3 h-5 items-center rounded-full px-2 py-1 text-white bg-orange-400">
              paiement
            </div>
          )}
          {message_folder.blocked && (
            <div className="inline-flex  text-h3 h-5 items-center rounded-full px-2 py-1 text-white bg-red-400">
              bloqué
            </div>
          )}
          {message_folder.late && (
            <div className="text-h3 h-5 items-center">
              <div className="inline-flex items-center rounded-full h-full px-2 py-1 text-white bg-red-400">
                retard
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConvMessage;

const AssistantColorName = ({ name, users }) => {
  for (const member of users) {
    if (member.display_name === name) {
      return (
        <div
          className="inline-flex w-fit text-h3 items-center rounded-full px-2 "
          style={{
            backgroundColor: intToHexColor(member.color),
            color: isColorTooDark(intToHexColor(member.color))
              ? "white"
              : "black",
          }}
        >
          {member.display_name}
        </div>
      );
    }
  }
};
